import React, { useState } from 'react';
import { LuCheck, LuChevronDown, LuRoute } from 'react-icons/lu';
import { horaTexto } from '../../utils/ordenes';

// "Tu recorrido de hoy" (13-oct-2026): las visitas del día como paradas numeradas, en orden de hora.
// Solo la próxima va abierta (con Salir / Llegué); las demás en una línea, se abren al tocarlas.
// Las hechas quedan tachadas en verde para ver el avance.
const ABIERTAS = ['EN_SITIO', 'EN_CAMINO'];

export default function RecorridoHoy({ paradas, horaOrden, onRuta, renderCard, onVerHecha = null }) {
    const [elegida, setElegida] = useState(null);
    const pendientes = paradas.filter(p => !p.hecha);
    const enCurso = pendientes.find(p => ABIERTAS.includes(p.orden.estado));
    const proxima = enCurso || pendientes[0];
    const abierta = pendientes.some(p => p.orden.id === elegida) ? elegida : proxima?.orden.id;
    const hechas = paradas.length - pendientes.length;

    return (
        <div className="mb-5">
            <div className="flex items-center justify-between gap-2 mb-2">
                <div>
                    <p className="text-label font-black uppercase tracking-wider text-muted">Tu recorrido de hoy</p>
                    <p className="text-caption font-bold text-secondary">{hechas} de {paradas.length} hechas</p>
                </div>
                {pendientes.length > 0 && (
                    <button type="button" onClick={onRuta}
                        className="h-9 px-3 shrink-0 rounded-xl bg-brand-red text-white text-label font-black inline-flex items-center gap-1.5 active:scale-95">
                        <LuRoute size={14} /> Ver en el mapa
                    </button>
                )}
            </div>
            <div className="h-1.5 rounded-full bg-chip overflow-hidden mb-3">
                <div className="h-full rounded-full bg-[#16A34A] transition-all" style={{ width: `${(hechas / paradas.length) * 100}%` }} />
            </div>

            <ol className="space-y-2">
                {paradas.map((p, i) => {
                    const o = p.orden;
                    const esAbierta = !p.hecha && o.id === abierta;
                    const esProxima = !p.hecha && o.id === proxima?.orden.id;
                    const hora = horaOrden(o.horaEstimada) === '99' ? 'Sin hora' : horaTexto(o.horaEstimada);
                    // Una hecha con trabajo cargado se toca para verlo y sumarle equipos (21-oct-2026)
                    const verHecha = p.hecha && onVerHecha && (o.servicioId || o.presupuestoId);
                    return (
                        <li key={o.id}>
                            <button type="button" disabled={p.hecha && !verHecha} onClick={() => (verHecha ? onVerHecha(o) : setElegida(esAbierta ? -1 : o.id))}
                                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-2xl text-left border transition-all ${
                                    esAbierta ? 'bg-card border-brand-red/50'
                                        : p.hecha ? 'bg-transparent border-black/[0.05] dark:border-white/[0.05]'
                                            : 'bg-card border-black/[0.07] dark:border-white/[0.07] active:scale-[0.99]'}`}>
                                <span className={`w-7 h-7 rounded-full shrink-0 flex items-center justify-center text-label font-black ${
                                    p.hecha ? 'bg-[#16A34A] text-white' : esProxima ? 'bg-brand-red text-white' : 'bg-chip text-secondary'}`}>
                                    {p.hecha ? <LuCheck size={14} /> : i + 1}
                                </span>
                                <span className="flex-1 min-w-0">
                                    <span className={`block text-caption font-black truncate ${p.hecha ? 'text-muted line-through' : 'text-ink'}`}>
                                        {o.titulo?.replace(/^Visita · /, '') || o.clienteNombre}
                                    </span>
                                    <span className="block text-label text-muted truncate">
                                        {p.hecha ? (o.estado === 'NO_ATENDIDO' ? 'No atendió' : verHecha ? 'Hecha · ver o sumar equipos' : 'Hecha') : o.direccion || 'Sin dirección'}
                                    </span>
                                </span>
                                <span className="shrink-0 text-right">
                                    <span className={`block text-caption font-black ${p.hecha ? 'text-muted' : esProxima ? 'text-brand-amber' : 'text-ink'}`}>{hora}</span>
                                    {esProxima && !esAbierta && <span className="block text-label font-black text-brand-red">Próxima</span>}
                                </span>
                                {!p.hecha && <LuChevronDown size={15} className={`shrink-0 text-muted transition-transform ${esAbierta ? 'rotate-180' : ''}`} />}
                            </button>
                            {esAbierta && (
                                <div className="mt-2 mb-4">
                                    {renderCard(o)}
                                </div>
                            )}
                        </li>
                    );
                })}
            </ol>
        </div>
    );
}
